<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-xl-7 login-left-section d-none d-xl-block"></div>
      <div class="col-xl-5 col-12 p-0">
        <div class="login-card">
          <div>
            <div>
              <router-link class="logo" to="/">
                <img v-if="logoUrl" class="img-fluid" :src="logoUrl" alt="Dashboard Admin" />
                <span v-else class="logo-text">Dashboard Admin</span>
              </router-link>
            </div>
            <div class="login-main">
              <form class="theme-form" @submit.prevent="doLogin">
                <h4 class="text-center">Iniciar sesión</h4>
                <p class="text-center">Ingresa tu email y contraseña</p>

                <div class="form-group">
                  <label class="col-form-label">Email</label>
                  <input v-model="email" class="form-control" type="email" placeholder="usuario@ejemplo.com" required />
                </div>
                <div class="form-group">
                  <label class="col-form-label">Contraseña</label>
                  <div class="form-input position-relative">
                    <input v-model="password" :type="passwordType" class="form-control" placeholder="*********"
                      required />
                    <div class="show-hide">
                      <span class="show" @click="passwordType = passwordType === 'password' ? 'text' : 'password'" />
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" v-model="remember" type="checkbox" />
                    <label class="text-muted" for="checkbox1">Recordar sesión</label>
                  </div>
                  <br>
                  <div class="text-end mt-3">
                    <button class="btn btn-primary btn-block w-100" type="submit" :disabled="loading">
                      {{ loading ? 'Iniciando...' : 'Iniciar sesión' }}
                    </button>
                  </div>
                </div>
                <br>
                <br>
                <br>
                <br>
                <div class="text-center legal-links">
                  <router-link class="legal-link" to="/legal/terminos">Términos y condiciones</router-link>
                  <span class="mx-2 text-muted">|</span>
                  <router-link class="legal-link" to="/legal/privacidad">Política de privacidad</router-link>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { loginWithBackend } from '@/services/authApi';
import { saveSession } from '@/services/session';

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      passwordType: 'password',
      remember: false,
      loading: false,
    };
  },
  computed: {
    logoUrl() {
      // Agrega logo en src/assets/images/logo/logo2.png para mostrarlo
      return null;
    },
  },
  methods: {
    async doLogin() {
      this.loading = true;

      try {
        const session = await loginWithBackend({
          email: this.email,
          password: this.password,
        });
        saveSession(session);

        await Swal.fire({
          icon: 'success',
          title: '¡Bienvenido!',
          text: 'Sesión iniciada correctamente',
          timer: 1500,
          showConfirmButton: false,
        });

        this.$router.replace('/');
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error al iniciar sesión',
          text: err.message || 'Verifica tu email y contraseña',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.legal-link {
  font-size: 0.9rem;
}
</style>
